import type { Ref } from 'react';
import { forwardRef } from 'react';
import { ProgressRing } from '@/components/presentation/ProgressRing';
import styles from './style/ProgressOverlay.module.css';

type Props = {
  progress: number;
};

export const ProgressOverlay = forwardRef(({ progress }: Props, ref: Ref<HTMLDivElement>) => {

  return (
    <div className={styles.root} ref={ref}>
      <ProgressRing
        progress={progress}
        progressColor="var(--gray-m)"
        size={80}
        strokeWidth={8} />
    </div>
  );
});

export default ProgressOverlay;